import { useContext } from 'react';
import { Form } from 'react-bootstrap';
import { FormattedMessage } from 'react-intl';

import { useTrackEvent } from '@/App/Blotter/useTrackEvent.ts';
import { OrderRow } from '@/App/tiles/orders/components/OrderRow.tsx';
import { FixingContext, useValidateFixing } from '@/App/tiles/orders/FixingOrder/FixingContext.tsx';
import { useAppSelector } from '@/store/hooks.ts';
import { selectFixingIsCcyForcedBidAsk, selectFixingPriceType } from '@/store/orders/fixing/selectors.ts';

export const FixingPriceType = () => {
  const tileId = useContext(FixingContext).tileId;
  const fixingPriceType = useAppSelector((state) => selectFixingPriceType(state, tileId));
  const isCcyForcedBidAsk = useAppSelector((state) => selectFixingIsCcyForcedBidAsk(state, tileId));
  const track = useTrackEvent();

  const validateFixing = useValidateFixing();

  const handleChangeReference = (event: React.ChangeEvent<HTMLSelectElement>) => {
    track('Order action', 'Price type changed');
    const newPriceType = event.target.value as 'MID' | 'BIDASK';

    validateFixing({
      fixingPriceType: newPriceType,
      fixingMarginType: newPriceType === 'BIDASK' ? 'MarginInBps' : undefined,
    });
  };

  return (
    <OrderRow labelId="order.fields.priceType">
      <Form.Select value={fixingPriceType} onChange={handleChangeReference} size="sm" data-e2e="price-type-selector">
        {!isCcyForcedBidAsk && (
          <option key="MID" value="MID">
            <FormattedMessage id="order.form.priceType.MID" />
          </option>
        )}
        <option key="BIDASK" value="BIDASK">
          <FormattedMessage id="order.form.priceType.BIDASK" />
        </option>
      </Form.Select>
    </OrderRow>
  );
};
